import { Injectable } from '@angular/core';

import { Config } from './config.model';
import { RawConfig } from './raw-config.model';

@Injectable()
export class ConfigService {
    private static staticConfig: Config;

    // noinspection JSMethodCanBeStatic
    get config(): Config {
        return ConfigService.staticConfig;
    }

    static SET_CONFIG(rawConfig: RawConfig): void {
        this.staticConfig = new Config(rawConfig);
    }
}
